// Verbose debug logs are dev-only — import.meta.env.DEV is false in production builds.
// Error logs stay on in production too, since they're low-frequency and meant to
// surface real failures (future: forward to an external tracking service).
export const DEBUG_CONFIG = {
  ENABLE_SESSION_LOGS: import.meta.env.DEV,
  ENABLE_DB_LOGS: import.meta.env.DEV,
  ENABLE_ERROR_LOGS: true,
};

export function logSession(...args: unknown[]) {
  if (DEBUG_CONFIG.ENABLE_SESSION_LOGS) {
    console.log('[DEBUG-SESSION]', new Date().toISOString(), ...args);
  }
}

export function logDB(...args: unknown[]) {
  if (DEBUG_CONFIG.ENABLE_DB_LOGS) {
    console.log('[DEBUG-DB]', new Date().toISOString(), ...args);
  }
}

/**
 * Log errors with context for debugging and future telemetry.
 * Includes timestamp, category, error stack, and custom context.
 */
export interface ErrorLogContext {
  category: string;
  error: Error;
  context?: Record<string, unknown>;
  severity?: 'low' | 'medium' | 'high' | 'critical';
}

export function logError(ctx: ErrorLogContext) {
  if (!DEBUG_CONFIG.ENABLE_ERROR_LOGS) return;

  const timestamp = new Date().toISOString();
  const severity = ctx.severity || 'medium';
  const severityIcon =
    severity === 'critical'
      ? '🔴'
      : severity === 'high'
        ? '🟠'
        : severity === 'medium'
          ? '🟡'
          : '🟢';

  console.error(
    `${severityIcon} [ERROR-${ctx.category.toUpperCase()}] ${timestamp}`,
    ctx.error.message,
    ctx.error.stack,
    ctx.context ? '| Context:' : '',
    ctx.context
  );

  // TODO: Send to external error tracking service (Sentry, etc.)
  // Example:
  // await fetch('/api/errors', {
  //   method: 'POST',
  //   body: JSON.stringify({
  //     timestamp,
  //     category: ctx.category,
  //     message: ctx.error.message,
  //     stack: ctx.error.stack,
  //     context: ctx.context,
  //     severity
  //   })
  // });
}
